"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useScrollbarSize = _interopRequireDefault(require("./useScrollbarSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-default-export */
var _default = _useScrollbarSize.default;
exports.default = _default;